import { Children, ReactNode } from 'react';

import { useScreenSizeDetection } from 'common/hooks';

const getNumberOfSections = (
  isMobile: boolean,
  isTablet: boolean,
  isDesktopOrLaptop: boolean,
  columns: number,
): number => {
  if (isDesktopOrLaptop) {
    return columns;
  } else if (isTablet) {
    return Math.ceil(columns / 2);
  }

  return Math.ceil(columns / 4);
};

const getNumberOfItems = (
  isMobile: boolean,
  isTablet: boolean,
  isDesktopOrLaptop: boolean,
  count: number,
  columns: number,
): number => {
  if (isDesktopOrLaptop) {
    return Math.ceil(count / columns);
  } else if (isTablet) {
    return Math.ceil(columns / (columns * 2));
  }

  return Math.ceil(columns / (columns * 4));
};

export const useMasonry = (
  columns: number,
  children: ReactNode | ReactNode[],
  direction: 'row' | 'column',
) => {
  const { isMobile, isTablet, isDesktopOrLaptop } = useScreenSizeDetection();
  const sectionItems: ReactNode[][] = [];
  const count = Children.count(children);

  if (!count) {
    return {
      sectionItems,
    };
  }

  const childrenArray = Children.toArray(children);

  if (direction === 'row') {
    const realSection = getNumberOfSections(isMobile, isTablet, isDesktopOrLaptop, columns);

    childrenArray.forEach((item, index) => {
      const itemGroup = index % realSection;
      (sectionItems[itemGroup] ||= []).push(item);
    });
  } else {
    const realItemCount = getNumberOfItems(isMobile, isTablet, isDesktopOrLaptop, count, columns);
    for (let index = 0; index < count; index += realItemCount) {
      const chunk = childrenArray.slice(index, index + realItemCount);
      (sectionItems[index] ||= []).push(chunk);
    }
  }

  return {
    sectionItems,
  };
};
